export default "__VITE_ASSET__1lFNBfmd__"